import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import Img from 'gatsby-image';
import { StaticQuery, graphql } from 'gatsby';
import { KarusellWrapper } from './Grid';

const SINGLE_IMAGE = graphql`
	{
		slide2: file(relativePath: { eq: "slide2.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1700) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		slide3: file(relativePath: { eq: "slide3.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1700) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		slide4: file(relativePath: { eq: "slide4.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1700) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
		slide5: file(relativePath: { eq: "slide5.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1700) {
					...GatsbyImageSharpFluid_tracedSVG
				}
			}
		}
	}
`;

export default function ControlledCarousel() {
	const [ index, setIndex ] = useState(0);

	const handleSelect = (selectedIndex, e) => {
		setIndex(selectedIndex);
	};

	return (
		<StaticQuery
			query={SINGLE_IMAGE}
			render={(data) => {
				const slide2 = data.slide2.childImageSharp.fluid;
				const slide3 = data.slide3.childImageSharp.fluid;
				const slide4 = data.slide4.childImageSharp.fluid;
				const slide5 = data.slide5.childImageSharp.fluid;
				return (
					<KarusellWrapper>
						<Carousel activeIndex={index} onSelect={handleSelect}>
							<Carousel.Item>
								<Img fluid={slide2} className="blur d-block w-100" alt="First slide" />
							</Carousel.Item>

							<Carousel.Item>
								<Img fluid={slide3} className="blur d-block w-100" alt="First slide" />
							</Carousel.Item>
							<Carousel.Item>
								<Img fluid={slide4} className="blur d-block w-100" alt="First slide" />
							</Carousel.Item>
							<Carousel.Item>
								<Img fluid={slide5} className="blur d-block w-100" alt="First slide" />
							</Carousel.Item>
						</Carousel>
					</KarusellWrapper>
				);
			}}
		/>
	);
}
